import { appointmentsRef } from "@/firebase.js";
import Vue from "vue";
import { dataB } from "../firebase";

export default {
  state: {
    appointments: [],
    selectedAppointment: null,
    currentDate: Vue.moment()
  },
  mutations: {
    setAppointments (state, appointments) {
      state.appointments = appointments;
    },
    setSelectedAppointment (state, appointment) {
      state.selectedAppointment = appointment;
    },
    setCurrentDate (state, date) {
      state.currentDate = date;
    }
  },
  actions: {
    async loadAppointments ({ commit, dispatch, rootState }) {
      // await setTimeout(() => {
        appointmentsRef
          .where("PersonID", "==", rootState.users.userData.PersonID)
          .orderBy("StartDate", "desc").onSnapshot(querySnapshot => {
          let appointmentList = [];

          querySnapshot.forEach(appointment => {
            let data = appointment.data();

            let transformedData = {
              id: appointment.id,
              startDate: Vue.moment(new Date(data.StartDate.seconds * 1000)).add(12, "hours"),
              endDate: Vue.moment(new Date(data.EndDate.seconds * 1000)).add(12, "hours"),
              text: data.Address ? data.Address + ", " + data.Details : data.Details,
              description: data.Type + "\n" + (data.Address ? data.Address + "\n" + data.Details : data.Details),
              startDateTimeZone: "NZ",
              endDateTimeZone: "NZ",
              data: data
            };
            if (data.TypeID === 1 || data.TypeID === 11) {
              transformedData.html = `<div style="display:inline-block;height:10px;width:10px;background:#88b335"></div>&nbsp;${transformedData.text}`;
            }
            appointmentList.push(transformedData);
          });
          commit("setAppointments", appointmentList);
        });
      // }, 2000);
    },
    async openAppointment ({ commit, dispatch }, id) {
      let appointmentQry = await appointmentsRef.doc(id).get();
      let appointment = appointmentQry.data();

      commit("setSelectedAppointment", appointment);
    },
    setCurrentDate ({ commit }, date) {
      commit("setCurrentDate", date);
    }
  },
  getters: {
    appointments (state) {
      return state.appointments;
    },
    selectedAppointment (state) {
      return state.selectedAppointment;
    },
    currentDate (state) {
      return state.currentDate;
    }
  }
};
